import { useEffect, useState } from 'react'
import { createFileRoute, useLoaderData } from '@tanstack/react-router'

import { RootStore } from '~/store/RootStore'

import { ContentWrapper, Spacer } from '~/components/elements'
import ServiceBanners from '~/components/home/ServiceBanners'
import Loading from '~/components/loading'
import UsageWidget from '~/components/usage/UsageWidget'
import PhoneNumber from '~/components/home/PhoneNumber'
import VoIPConfigurationDetails from '~/components/home/VoIPConfigurationDetails'
import ServiceAgreement from '~/components/home/ServiceAgreement'
import CurrentPlanWidget from '~/components/home/CurrentPlan'
import AddOns from '~/components/home/AddOns'
import Tools from '~/components/home/Tools'
import Poi from '~/components/home/POI'
import VoIPSettings from '~/components/home/VoIPSettings'
import { Constants } from '~/utils/Constants'

export const Route = createFileRoute('/_authenticated/home/')({
  head: () => ({
    meta: [
      {
        title: `Home | Self Service Portal`,
      },
    ],
  }),
  beforeLoad: async ({ context }: any) => {
    // this will run if we are authenticated
    const store = context.store
    if (store) {
      const { account } = store
      if (!account.profile) {
        await account.loadProfile()
      }
      if (account.services.length === 0) {
        await account.loadServices()
      }
    }
  },
  loader: async ({ context }: any) => {
    const store: RootStore = context.store
    const currentService = store.account.getCurrentService

    return {
      currentService: currentService,
    }
  },
  pendingComponent: () => <Loading />,
  component: HomePage,
})

function HomePage() {
  const { currentService } = useLoaderData({ from: '/_authenticated/home/' })
  const [serviceLoaded, setServiceLoaded] = useState(false)

  useEffect(() => {
    if (currentService && currentService.code) {
      setServiceLoaded(true)
    }
  }, [])

  return (
    <ContentWrapper>
      {serviceLoaded && (
        <>
          <ServiceBanners />
          {/* <ServiceDisplay /> */}

          {/* Usage */}
          <UsageWidget />

          <PhoneNumber />
          <VoIPConfigurationDetails />
          <ServiceAgreement />
          <CurrentPlanWidget />
          <AddOns />
          {Constants.WHOLESALERSETTINGS.code !== 'OE' && (
            <>
              <Spacer height="24px" />
              <Tools />

              <Spacer height="12px" />
              <Poi />
            </>
          )}
          <VoIPSettings />
        </>
      )}
    </ContentWrapper>
  )
}
